import React from "react";
import "../assets/css/Header.css";
import "../assets/css/MobileMenu.css";
import { useContext, useEffect } from "react";
import Contexto from "../context/Contexto";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ImgEntrar from "./ImgEntrar";
import Logo from "../assets/CCstatics/COLOR_CLUB.svg";
import cerrar from "../assets/CCstatics/cerrar.svg";
import { Link } from "react-router-dom";

function MobileMenu(props) {
  const {
    cliente,
    desconectarUsuario,
    Griseado,
    canjearCursos,
    usuario,
    loguearUsuario,
    CC,
  } = useContext(Contexto);
  const navigate = useNavigate();

  const { estado, accion } = props;
  const redireccionar = (url) => {
    accion();
    if (url === "desloguear") {
      desconectarUsuario();
      Griseado("/");
    } else {
      Griseado(url);
    }
  };
  const [codiguito, setCodiguito] = useState("");
  const handleCodigo = (e) => {
    setCodiguito(e.target.value);
  };
  const dameRegalo = () => {
    console.log("dameRegalo()", codiguito);
    canjearCursos({ codigo: codiguito, pibe: usuario.uid });
  };
  useEffect(() => {
    console.log("lo que trae CC", CC);
  }, [cliente]);

  return (
    <div className={estado} id="menuMobile">
      <header className="header">
        <p>.</p>

        <Link to="https://www.colorclub.online/" className="logoLink">
          <img src={Logo} alt="" className="CCL" />
        </Link>
        <img src={cerrar} className="burguer" alt="" onClick={accion} />
      </header>

      {cliente && (
        <>
          <div className="infoCliente">
            <ul>
              {/* <h1 className="">{cliente.username}</h1> */}
              {cliente.vencimientos && (
                <li
                  className="bbt violetaB"
                  onClick={() => redireccionar("/miscursos")}
                >
                  Mis cursos
                </li>
              )}

              <li
                onClick={() => redireccionar("/miperfil")}
                className="bbt naranjaB"
              >
                Mi Perfil
              </li>

              {CC.estado && (
                <li
                  onClick={() => redireccionar("/plan")}
                  className="bbt amarilloB"
                >
                  Plan
                </li>
              )}
            </ul>
          </div>
        </>
      )}
      <ul>
        <li className="bbt celesteB">
          <Link to="https://discord.com/invite/UgkCEm6DQV" className="blaco">
            Discord
          </Link>
        </li>
        <li
          onClick={() => {
            redireccionar("desloguear");
          }}
          className="bbt violetaB"
        >
          CERRAR SESIÓN
        </li>

        {
          //cliente && (
          // <div className="regalines">
          //   <h3 className="txtLetrita white"> Tenés un código de regalo?</h3>
          //   <input
          //     type="text"
          //     onChange={handleCodigo}
          //     className="regalin"
          //     placeholder="Ingresá tu código"
          //   />
          //   <br /> <br />
          //   <button onClick={dameRegalo} className="infoClientebtn">
          //     Dame mi regalo
          //   </button>
          //   <br />
          // </div>
          // )
        }
      </ul>

      <ul>
        <li>
          {!cliente && (
            <ImgEntrar
              accion={loguearUsuario}
              className="header-menuHamburguesa"
              fill="white"
              Hover="#01ff00"
              width="50px"
              height="30px"
            ></ImgEntrar>
          )}
        </li>
      </ul>
    </div>
  );
}

export default MobileMenu;
